export function getPartialSearchQuery({
  keyList,
  search,
}: {
  search: string;
  keyList: string[];
}): string {
  const baseSearch = new URLSearchParams(search);

  const partialSearch = new URLSearchParams();
  [...baseSearch.entries()].forEach(([key, value]) => {
    if (keyList.includes(key)) {
      partialSearch.set(key, value);
    }
  });
  return partialSearch.toString();
}
